var React = require('react');

function IcnClose (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs4","key":0}),React.createElement("g",{"id":"layer1","transform":"translate(0,-1036.3622)","key":1},[React.createElement("path",{"d":"m 2,1050.3622 12,-12","id":"path2985","style":{"fill":"none","stroke":"#FFFFFF","strokeWidth":"2","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"4","strokeOpacity":"1","strokeDasharray":"none"},"key":0}),React.createElement("path",{"d":"m 2,1038.3622 12,12","id":"path2985-1","style":{"fill":"none","stroke":"#FFFFFF","strokeWidth":"2","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"4","strokeOpacity":"1","strokeDasharray":"none"},"key":1})])]);
}

IcnClose.defaultProps = {"height":"16","id":"svg2","version":"1.1","width":"16"};

module.exports = IcnClose;

IcnClose.default = IcnClose;
